<template>
  <div class="position-management">
    <!-- 页面头部 -->
    <div class="header">
      <div class="header-left">
        <button class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <div class="title">推广位管理</div>
      </div>
    </div>

    <!-- 操作工具栏 -->
    <div class="toolbar">
      <div class="toolbar-left">
        <button @click="batchUpdateInviteCodeStatus('ACTIVE')" :disabled="selectedItems.length === 0"
          class="btn1 btn-success">
          <i class="icon-check"></i> 启码
        </button>
        <button @click="batchUpdateInviteCodeStatus('INACTIVE')" :disabled="selectedItems.length === 0"
          class="btn1 btn-warning">
          <i class="icon-close"></i> 禁码
        </button>
        <button @click="batchToggleStatus(true)" :disabled="selectedItems.length === 0" class="btn1 btn-success">
          <i class="icon-check"></i> 启用
        </button>
        <button @click="batchToggleStatus(false)" :disabled="selectedItems.length === 0" class="btn1 btn-warning">
          <i class="icon-close"></i> 禁用
        </button>
        <button @click="batchDelete" :disabled="selectedItems.length === 0" class="btn1 btn-danger">
          <i class="icon-delete"></i> 删除
        </button>
      </div>

      <div class="toolbar-right">
        <div style="width: 100%;display: flex; align-items: center; gap: 10px;">
          <el-input style="flex: 1;" v-model="searchForm.positionId" placeholder="推广位ID" clearable />
          <el-input style="flex: 1;" v-model="searchForm.positionName" placeholder="推广位名称" clearable />
        </div>
        <el-select v-model="searchForm.isUse" placeholder="全部状态" clearable>
          <el-option label="全部状态" value="" />
          <el-option label="启用" value="true" />
          <el-option label="禁用" value="false" />
        </el-select>
        <div style="width: 100%;display: flex; align-items: center; justify-content: space-between;gap: 10px;">
          <button @click="showCreateModal" class="btn btn-primary" style="flex: 1;text-align: center;">
            新增
          </button>

          <button @click="searchPositions" class="btn btn-secondary" style="flex: 1;">
            搜索
          </button>

          <button @click="resetSearch" class="btn btn-outline" style="flex: 1;">
            重置
          </button>
        </div>
      </div>
    </div>

    <!-- 内容列表 -->
    <div class="content-table-container">
      <el-table :data="positions" style="width: 100%" empty-text="暂无推广位数据" v-loading="loading"
        height="calc(100vh - 255px)" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45" align="center"></el-table-column>
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="positionId" label="推广位ID" width="120" align="center"></el-table-column>
        <el-table-column prop="positionPsd" label="推广位密码" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.positionPsd || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="positionName" label="推广位名称" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.positionName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="siteId" label="媒体ID" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.siteId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sceneId" label="场景ID" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sceneId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isLeader" label="是否团长" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isLeader ? 'success' : 'info'" size="small">
              {{ scope.row.isLeader ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="leaderSiteId" label="团长媒体ID" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.leaderSiteId || '-' }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="inviteCodeStatus" label="邀请码状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.inviteCodeStatus === 'ACTIVE' ? 'success' : 'danger'" size="small">
              {{ scope.row.inviteCodeStatus === 'ACTIVE' ? '有效' : '无效' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isUse" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isUse ? 'success' : 'danger'" size="small">
              {{ scope.row.isUse ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ formatDateTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="updateTime" label="更新时间" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ formatDateTime(scope.row.updateTime) }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="phone" label="手机号" width="150" align="center">
        </el-table-column>
        <el-table-column label="操作" width="210" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editPosition(scope.row)">
              编辑
            </el-button>
            <el-button size="mini" :type="scope.row.isUse ? 'warning' : 'success'" @click="toggleStatus(scope.row)">
              {{ scope.row.isUse ? '禁用' : '启用' }}
            </el-button>
            <el-button size="mini" type="danger" @click="deletePosition(scope.row)">
              删除
            </el-button>
            <el-button size="mini" type="primary" @click="viewPosition(scope.row)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination" v-if="totalPages > 1">
        <button @click="prevPage" :disabled="currentPage <= 0">上一页</button>
        <span>{{ currentPage + 1 }} / {{ totalPages }}</span>
        <button @click="nextPage" :disabled="currentPage >= totalPages - 1">下一页</button>
      </div>
    </div>

    <!-- 新增/编辑模态框 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <h3>{{ isEdit ? '编辑推广位' : '新增推广位' }}</h3>
        <el-form :model="formData" label-width="100px" size="small">
          <el-form-item label="推广位ID *">
            <el-input v-model="formData.positionId" placeholder="请输入推广位ID" :disabled="isEdit" />
          </el-form-item>
          <el-form-item label="推广位密码 *">
            <el-input v-model="formData.positionPsd" placeholder="请输入推广位密码" />
          </el-form-item>
          <el-form-item label="推广位名称 *">
            <el-input v-model="formData.positionName" placeholder="请输入推广位名称" />
          </el-form-item>
          <el-form-item label="媒体ID *">
            <el-select v-model="formData.siteId" placeholder="请选择媒体ID" clearable style="width: 100%;">
              <el-option label="请选择媒体ID" value="" />
              <el-option v-for="site in activeSites" :key="site.id" :label="`${site.siteId} - ${site.siteName}`"
                :value="site.siteId" />
            </el-select>
          </el-form-item>
          <el-form-item label="场景ID">
            <el-radio-group v-model="formData.sceneId">
              <el-radio style="width: 50px;" :label="1">1</el-radio>
              <el-radio style="width: 50px;" :label="2">2</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否团长">
            <el-switch v-model="formData.isLeader" />
          </el-form-item>
          <el-form-item label="团长媒体ID" v-if="formData.isLeader">
            <el-select v-model="formData.leaderSiteId" placeholder="请选择团长媒体ID" clearable style="width: 100%;">
              <el-option label="请选择团长媒体ID" value="" />
              <el-option v-for="site in activeSites" :key="site.id" :label="`${site.siteId} - ${site.siteName}`"
                :value="site.siteId" />
            </el-select>
          </el-form-item>
          <el-form-item label="邀请码状态">
            <el-switch v-model="formData.inviteCodeStatus" active-value="ACTIVE" inactive-value="INACTIVE" />
          </el-form-item>
          <el-form-item label="状态">
            <el-switch v-model="formData.isUse" />
          </el-form-item>

          <div style="display: flex; gap: 10px;width: 100%;">
            <el-button type="primary" @click="savePosition" :disabled="saving" style="flex: 1;">
              {{ saving ? '保存中...' : '保存' }}
            </el-button>
            <el-button @click="closeModal" style="border: 1px solid #42b983;color: #42b983;flex: 1;">取消</el-button>
          </div>

        </el-form>
      </div>
    </div>
    <!-- 查看详情弹窗 -->
    <div v-if="showViewModal" class="modal-overlay" @click="closeViewModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>推广位详情</h3>
        </div>
        <div class="modal-body">
          <div class="detail-grid">
            <div class="detail-row">
              <span class="label">推广位ID：</span>
              <span class="value">{{ viewPositionData.positionId || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">推广位密码：</span>
              <span class="value">{{ viewPositionData.positionPsd || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">推广位名称：</span>
              <span class="value">{{ viewPositionData.positionName || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">媒体ID：</span>
              <span class="value">{{ viewPositionData.siteId || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">场景ID：</span>
              <span class="value">{{ viewPositionData.sceneId || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">是否团长：</span>
              <span class="value">{{ viewPositionData.isLeader ? '是' : '否' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">团长媒体ID：</span>
              <span class="value">{{ viewPositionData.leaderSiteId || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">邀请码状态：</span>
              <span class="value">{{ viewPositionData.inviteCodeStatus || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">状态：</span>
              <span class="value">{{ viewPositionData.isUse ? '启用' : '禁用' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">手机号：</span>
              <span class="value">{{ viewPositionData.phone || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">银行卡号：</span>
              <span class="value">{{ viewPositionData.bankAccount || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">开户银行：</span>
              <span class="value">{{ viewPositionData.bankName || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">支付宝：</span>
              <span class="value">{{ viewPositionData.alipayAccount || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">支手机号：</span>
              <span class="value">{{ viewPositionData.alipayPhone || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">微信：</span>
              <span class="value">{{ viewPositionData.wechatAccount || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">微手机号：</span>
              <span class="value">{{ viewPositionData.wechatPhone || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">闲鱼号：</span>
              <span class="value">{{ viewPositionData.xyNumber || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">抖音号：</span>
              <span class="value">{{ viewPositionData.dyNumber || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">小红书：</span>
              <span class="value">{{ viewPositionData.xhNumber || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">视频号：</span>
              <span class="value">{{ viewPositionData.spNumber || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">邀请码：</span>
              <span class="value">{{ viewPositionData.inviteCode || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="label">邀请层级：</span>
              <span class="value">{{ viewPositionData.inviteLevel || 0 }}</span>
            </div>
            <div class="detail-row">
              <span class="label">创建时间：</span>
              <span class="value">{{ formatDateTime(viewPositionData.createTime)
              }}</span>
            </div>
            <div class="detail-row">
              <span class="label">更新时间：</span>
              <span class="value">{{ formatDateTime(viewPositionData.updateTime)
              }}</span>
            </div>
          </div>
        </div>
        <el-button style="border: 1px solid #42b983;color: #42b983;width: 100%;margin-top: 10px;"
          @click="closeViewModal">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  createPosition,
  updatePosition,
  deletePosition,
  getPositions,
  togglePositionStatus,
  getActiveSites,
  batchUpdateInviteCodeStatus,
  batchTogglePositionStatus,
  batchDeletePositions
} from '@/utils/jdApi'

export default {
  name: 'PositionManagement',
  data() {
    return {
      loading: false,
      saving: false,
      showModal: false,
      isEdit: false,
      positions: [],
      currentPage: 0,
      pageSize: 50,
      totalPages: 0,
      totalElements: 0,
      searchForm: {
        positionId: '',
        positionName: '',
        isUse: ''
      },
      formData: {
        positionId: '',
        positionPsd: '',
        positionName: '',
        siteId: '',
        sceneId: 1,
        isLeader: false,
        leaderSiteId: '',
        isUse: true,
        inviteCodeStatus: 'INACTIVE'
      },
      activeSites: [],
      selectedItems: [],
      // 查看详情弹窗数据
      showViewModal: false,
      viewPositionData: {}
    }
  },
  mounted() {
    this.loadPositions()
    this.loadActiveSites()
  },
  methods: {
    async loadPositions() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          positionId: this.searchForm.positionId || undefined,
          positionName: this.searchForm.positionName || undefined,
          isUse: this.searchForm.isUse ? this.searchForm.isUse === 'true' : undefined
        }
        const response = await getPositions(params)
        if (response.success) {
          this.positions = response.data
          this.totalPages = response.totalPages
          this.totalElements = response.totalElements
        }
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },

    async loadActiveSites() {
      try {
        const response = await getActiveSites()
        if (response.success) {
          this.activeSites = response.data
        }
      } catch (error) {
        this.$message.error('加载失败')
      }
    },

    async searchPositions() {
      this.currentPage = 0
      await this.loadPositions()
    },

    resetSearch() {
      this.searchForm = {
        positionId: '',
        positionName: '',
        isUse: ''
      }
      this.currentPage = 0
      this.loadPositions()
    },

    refreshPositions() {
      this.loadPositions()
    },

    showCreateModal() {
      this.isEdit = false
      this.formData = {
        positionId: '',
        positionPsd: '',
        positionName: '',
        siteId: '',
        sceneId: 1,
        isLeader: false,
        leaderSiteId: '',
        isUse: true,
        inviteCodeStatus: 'INACTIVE'
      }
      this.showModal = true
    },

    editPosition(position) {
      this.isEdit = true
      this.formData = {
        positionId: position.positionId,
        positionPsd: position.positionPsd || '',
        positionName: position.positionName || '',
        siteId: position.siteId || '',
        sceneId: position.sceneId || 1,
        isLeader: position.isLeader || false,
        leaderSiteId: position.leaderSiteId || '',
        isUse: position.isUse,
        inviteCodeStatus: position.inviteCodeStatus || 'INACTIVE'
      }
      this.editingId = position.id
      this.showModal = true
    },

    async savePosition() {
      this.saving = true
      try {
        let response
        if (this.isEdit) {
          response = await updatePosition(this.editingId, this.formData)
        } else {
          response = await createPosition(this.formData)
        }

        if (response.success) {
          this.closeModal()
          this.loadPositions()
        }
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },

    async toggleStatus(position) {
      if (!confirm(`确定要${position.isUse ? '禁用' : '启用'}推广位 "${position.positionId}" 吗？`)) {
        return
      }

      try {
        const response = await togglePositionStatus(position.id)
        if (response.success) {
          this.loadPositions()
        }
      } catch (e) {
        this.$message.error('操作失败')
      }
    },

    async deletePosition(position) {
      if (!confirm(`确定要删除推广位 "${position.positionId}" 吗？此操作不可恢复！`)) {
        return
      }

      try {
        const response = await deletePosition(position.id)
        if (response.success) {
          this.loadPositions()
        }
      } catch (e) {
        this.$message.error('删除失败')
      }
    },

    viewPosition(position) {
      this.viewPositionData = position || {}
      this.showViewModal = true
    },

    closeViewModal() {
      this.showViewModal = false
      this.viewPositionData = {}
    },

    closeModal() {
      this.showModal = false
      this.isEdit = false
      this.editingId = null
    },

    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--
        this.loadPositions()
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++
        this.loadPositions()
      }
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      return new Date(dateTime).toLocaleString('zh-CN')
    },

    goBack() {
      this.$router.go(-1)
    },

    handleSelectionChange(selection) {
      this.selectedItems = selection
    },

    async batchUpdateInviteCodeStatus(status) {
      if (this.selectedItems.length === 0) {
        this.$message.warning('请选择要操作的项目')
        return
      }

      if (!confirm(`确定要批量${status === 'ACTIVE' ? '启用' : '禁用'}邀请码吗？`)) {
        return
      }

      try {
        const ids = this.selectedItems.map(item => item.id)
        const response = await batchUpdateInviteCodeStatus(ids, status)
        if (response.success) {
          this.$message.success(`成功${status === 'ACTIVE' ? '启用' : '禁用'}${ids.length}条邀请码`)
          this.loadPositions()
          this.selectedItems = []
        }
      } catch (e) {
        this.$message.error('操作失败')
      }
    },

    async batchToggleStatus(isUse) {
      if (this.selectedItems.length === 0) {
        this.$message.warning('请选择要操作的项目')
        return
      }

      if (!confirm(`确定要批量${isUse ? '启用' : '禁用'}选中的推广位吗？`)) {
        return
      }

      try {
        const ids = this.selectedItems.map(item => item.id)
        const response = await batchTogglePositionStatus(ids, isUse)
        if (response.success) {
          this.$message.success(`成功${isUse ? '启用' : '禁用'}${ids.length}个推广位`)
          this.loadPositions()
          this.selectedItems = []
        } else {
          this.$message.error('操作失败')
        }
      } catch (e) {
        this.$message.error('操作失败')
      }
    },

    async batchDelete() {
      if (this.selectedItems.length === 0) {
        this.$message.warning('请选择要删除的项目')
        return
      }

      if (!confirm(`确定要删除选中的${this.selectedItems.length}个推广位吗？此操作不可恢复！`)) {
        return
      }

      try {
        const ids = this.selectedItems.map(item => item.id)
        const response = await batchDeletePositions(ids)
        if (response.success) {
          this.$message.success(`成功删除${ids.length}个推广位`)
          this.loadPositions()
          this.selectedItems = []
        } else {
          this.$message.error('删除失败')
        }
      } catch (e) {
        this.$message.error('删除失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.position-management {
  margin: 0 auto;
  padding: 10px;
  background: #f8f9fa;
  height: 100vh;
  box-sizing: border-box;
}

.header {
  background: linear-gradient(135deg, #42b983, #369870);
  color: white;
  padding: 4px;
  margin-bottom: 10px;
  flex-shrink: 0;
  border-radius: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: white;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
  width: 20px;
  height: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
  gap: 10px;
}

.toolbar-left {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
}

.search-filters .el-input {
  width: 150px;
}

.search-filters .el-select {
  width: 120px;
}

.btn {
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  outline: none;
}

.btn-primary {
  background: #42b983;
  color: white;
}

.btn-primary:hover {
  background: #369870;
}

.btn-secondary {
  background: #42b983;
  color: white;
}

.btn-secondary:hover {
  background: #42b983;
}

.btn-outline {
  background: transparent;
  color: #42b983;
  border: 1px solid #42b983;
}

.btn-outline:hover {
  background: #42b983;
  color: white;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.content-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  overflow-y: auto;
}

/* el-table 自定义样式 */
.content-table-container .el-table {
  border: none;
}

.content-table-container .el-table th {
  background: #f8f9fa;
  color: #495057;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
}

.content-table-container .el-table td {
  border-bottom: 1px solid #f1f3f4;
}

.content-table-container .el-table tbody tr:hover {
  background-color: #f8f9fa;
}

/* 操作按钮样式 */
.content-table-container .el-button--mini {
  padding: 5px 8px;
  margin: 0 2px;
}

/* 响应式 & 滚动条优化，参考攻略管理 */
.content-table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.content-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.content-table-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.content-table-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.content-table-container {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

@media (max-width: 768px) {
  .content-table-container {
    max-height: calc(100vh - 230px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .content-table-container .el-table {
    min-width: 600px;
  }

  .content-table-container .el-button--mini {
    padding: 3px 6px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .content-table-container .el-table {
    min-width: 480px;
  }
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 20px;
  background: white;
}

.pagination button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  border-radius: 4px;
}

.pagination button:hover:not(:disabled) {
  background: #f8f9fa;
}

.pagination button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 10px;
  border-radius: 8px;
  width: 500px;
  max-width: 90vw;
  margin: 10px;
}

.modal-content h3 {
  margin-top: 0;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.btn1 {
  background: #fff;
  border: 1px solid #42b983;
  color: #42b983;
  border-radius: 4px;
  flex: 1;
}

.detail-grid {
  height: calc(100vh - 300px);
  overflow-y: auto;

  .detail-row {
    display: flex;
    padding-bottom: 4px;
    align-items: center;

    .label {
      white-space: nowrap;
      width: 100px;
      color: #909399;
    }

    .value {
      color: #42b983;
    }
  }

}
</style>